import {all, fork, takeLatest, call, put, select} from 'redux-saga/effects';
import axios from 'axios';
import {
  NAVER_BATCH_STATUS_UPDATE_REQUEST,
  NAVER_BATCH_STATUS_UPDATE_SUCCESS,
  NAVER_BATCH_STATUS_UPDATE_FAILURE,
  PIXEL_STATUS_UPDATE_REQUEST,
  PIXEL_STATUS_UPDATE_SUCCESS,
  PIXEL_STATUS_UPDATE_FAILURE,
  LOAD_SYSTEM_SETTING_REQUEST,
  LOAD_SYSTEM_SETTING_SUCCESS,
  LOAD_SYSTEM_SETTING_FAILURE,
} from '../reducers/setting';

const getMe = state => {
  return state.user.me;
};

function naverBatchStatusUpdateAPI(user, data) {
  const token = `${localStorage.getItem('accessToken')}`;
  const brand = localStorage.getItem('selectedBrand') || '';
  
  return axios.post('/admins/naverBatchStatusUpdate', data, {
    withCredentials: true,
    headers: {
      Authorization: token,
      Brand: brand,
    },
  });
}

function* naverBatchStatusUpdate(action) {
  try {
    const user = yield select(getMe);
    const result = yield call(naverBatchStatusUpdateAPI, user, action.data);
    yield put({
      type: NAVER_BATCH_STATUS_UPDATE_SUCCESS,
      data: result.data,
    });
  } catch (e) {
    yield put({
      type: NAVER_BATCH_STATUS_UPDATE_FAILURE,
      error: e.response.data,
    });
  }
}

function pixelStatusUpdateAPI(user, data) {
  const token = `${localStorage.getItem('accessToken')}`;
  const brand = localStorage.getItem('selectedBrand') || '';
  
  return axios.post('/admins/pixelStatusUpdate', data, {
    withCredentials: true,
    headers: {
      Authorization: token,
      Brand: brand,
    },
  });
}

function* pixelStatusUpdate(action) {
  try {
    const user = yield select(getMe);
    const result = yield call(pixelStatusUpdateAPI, user, action.data);
    yield put({
      type: PIXEL_STATUS_UPDATE_SUCCESS,
      data: result.data,
    });
  } catch (e) {
    yield put({
      type: PIXEL_STATUS_UPDATE_FAILURE,
      error: e.response.data,
    });
  }
}

function loadSystemSettingAPI(user) {
  const token = `${localStorage.getItem('accessToken')}`;
  return axios.get('/admins/systemSetting', {
    withCredentials: true,
    headers: {
      Authorization: token,
    },
  });
}

function* loadSystemSetting(action) {
  try {
    const user = yield select(getMe);
    const result = yield call(loadSystemSettingAPI, user);
    yield put({
      type: LOAD_SYSTEM_SETTING_SUCCESS,
      data: result.data,
    });
  } catch (e) {
    yield put({
      type: LOAD_SYSTEM_SETTING_FAILURE,
      error: e.response.data,
    });
  }
}

function* watchNaverBatchStatusUpdate() {
  yield takeLatest(NAVER_BATCH_STATUS_UPDATE_REQUEST, naverBatchStatusUpdate);
}

function* watchPixelStatusUpdate() {
  yield takeLatest(PIXEL_STATUS_UPDATE_REQUEST, pixelStatusUpdate);
}

function* watchLoadSystemSetting() {
  yield takeLatest(LOAD_SYSTEM_SETTING_REQUEST, loadSystemSetting);
}

export default function* settingSaga() {
  yield all([
    fork(watchNaverBatchStatusUpdate),
    fork(watchPixelStatusUpdate),
    fork(watchLoadSystemSetting),
  ]);
}
